// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-title-container-ptQhl {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toolbar-title-icon-L4CEf {
  width: 22px;
  height: 22px;
  font-size: 22px;
}

.toolbar-title-title-lO5VG {
  font-size: 18px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/toolbar-title/toolbar-title.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.icon {\n  width: 22px;\n  height: 22px;\n  font-size: 22px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `toolbar-title-container-ptQhl`,
	"icon": `toolbar-title-icon-L4CEf`,
	"title": `toolbar-title-title-lO5VG`
};
export default ___CSS_LOADER_EXPORT___;
